// node_modules
import { FC } from "react";

export type TMediaPreviewTypedChildProps = {
    previewName: string,
    previewType: string,
    previewLink: string
    children: JSX.Element | JSX.Element[];
};

export const MediaPreviewTypedChild: FC<TMediaPreviewTypedChildProps> = ({ children }: TMediaPreviewTypedChildProps) => {
    return (
        <>
            {children}
        </>
    );
}